import React from 'react';
import styles from './styles.scss';

const Dropdown = React.memo(
  ({ className, name, optionValues, onChange, onBlur, initialValue }) => {
    const hasOptionValues = optionValues && optionValues.size > 0;

    return (
      <select
        className={`${styles.select} ${className ? className : ''}`}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        defaultValue={initialValue}
      >
        {hasOptionValues &&
          optionValues.map((optionValue) => {
            const id = optionValue.get('id');

            return (
              <option value={id} key={id}>
                {optionValue.get('name')}
              </option>
            );
          })}
      </select>
    );
  }
);

export default Dropdown;
